import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'

export const GridContainer = styled(({ margin, padding, ...props }) => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`
export const GridItem = styled(({ ...props }) => <GridBase item {...props} />)``
